import PhotoRelatedSearchLinksContainer from '../src/PhotoRelatedSearchLinksContainer';
export default PhotoRelatedSearchLinksContainer;
